/* Cart drawer "Pair with" slider controls.
   The theme re-renders the cart drawer innerHTML on every cart change, so all
   behaviour is delegated on document and (re)built idempotently.

   Provides:
   - mouse drag-to-scroll (touch scrolls natively)
   - prev/next arrow buttons
   - dot pagination synced to scroll position
   Arrows and dots are only shown when the track actually overflows. */
(function () {
  var TRACK = '.drawer--cart .cart__widget__products';

  /* ---- drag to scroll ---- */
  var el = null, startX = 0, startScroll = 0, dragging = false;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    var t = e.target.closest && e.target.closest(TRACK);
    if (!t) return;
    el = t; dragging = false; startX = e.clientX; startScroll = t.scrollLeft;
  });

  document.addEventListener('pointermove', function (e) {
    if (!el) return;
    var dx = e.clientX - startX;
    if (!dragging && Math.abs(dx) > 5) dragging = true;
    if (dragging) { el.scrollLeft = startScroll - dx; e.preventDefault(); }
  });

  function endDrag() {
    if (dragging) {
      var stop = function (ev) { ev.preventDefault(); ev.stopPropagation(); document.removeEventListener('click', stop, true); };
      document.addEventListener('click', stop, true);
      setTimeout(function () { document.removeEventListener('click', stop, true); }, 0);
    }
    el = null; dragging = false;
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  /* ---- arrows + dots ---- */
  function cardWidth(track) {
    var first = track.children[0];
    if (!first) return track.clientWidth;
    var style = getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function pageCount(track) {
    return Math.max(1, Math.round(track.scrollWidth / track.clientWidth));
  }

  function activeDot(track) {
    return Math.round(track.scrollLeft / track.clientWidth);
  }

  function buildControls(track) {
    var widget = track.closest('.cart__widget--products');
    if (!widget) return;
    var overflow = track.scrollWidth - track.clientWidth > 4;

    var existing = widget.querySelector('.dia-slider-nav');
    if (!overflow) { if (existing) existing.remove(); return; }
    if (existing) { syncDots(track); return; }

    var nav = document.createElement('div');
    nav.className = 'dia-slider-nav';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'dia-slider-arrow dia-slider-arrow--prev';
    prev.setAttribute('aria-label', 'Previous');
    prev.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'dia-slider-arrow dia-slider-arrow--next';
    next.setAttribute('aria-label', 'Next');
    next.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

    var dots = document.createElement('div');
    dots.className = 'dia-slider-dots';
    var pages = pageCount(track);
    for (var i = 0; i < pages; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'dia-slider-dot';
      dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
      dot.dataset.page = i;
      dots.appendChild(dot);
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -cardWidth(track), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: cardWidth(track), behavior: 'smooth' }); });
    dots.addEventListener('click', function (e) {
      var d = e.target.closest('.dia-slider-dot');
      if (!d) return;
      track.scrollTo({ left: track.clientWidth * parseInt(d.dataset.page, 10), behavior: 'smooth' });
    });

    nav.appendChild(prev);
    nav.appendChild(dots);
    nav.appendChild(next);
    widget.appendChild(nav);

    if (!track.dataset.diaSliderBound) {
      track.dataset.diaSliderBound = '1';
      track.addEventListener('scroll', function () {
        if (track._diaRaf) return;
        track._diaRaf = requestAnimationFrame(function () { track._diaRaf = null; syncDots(track); });
      });
    }
    syncDots(track);
  }

  function syncDots(track) {
    var widget = track.closest('.cart__widget--products');
    if (!widget) return;
    var nav = widget.querySelector('.dia-slider-nav');
    if (!nav) return;
    var active = activeDot(track);
    nav.querySelectorAll('.dia-slider-dot').forEach(function (d, i) {
      d.classList.toggle('is-active', i === active);
    });
    var atStart = track.scrollLeft <= 2;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    var prev = nav.querySelector('.dia-slider-arrow--prev');
    var next = nav.querySelector('.dia-slider-arrow--next');
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  }

  /* Rebuild whenever the drawer content changes. MutationObserver on body
     catches the theme's section re-render; debounced so it stays cheap. */
  var rebuildTimer = null;
  function scheduleRebuild() {
    clearTimeout(rebuildTimer);
    rebuildTimer = setTimeout(function () {
      document.querySelectorAll(TRACK).forEach(buildControls);
    }, 120);
  }

  var mo = new MutationObserver(scheduleRebuild);
  mo.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('load', scheduleRebuild);
})();
